module.exports = __webpack_public_path__ + "static/media/logo-mini.7d54345c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-mini.svg
// module id = 147
// module chunks = 0